import { render, staticRenderFns } from "./UpgradePlanModal.vue?vue&type=template&id=68bb844c&scoped=true&"
import script from "./UpgradePlanModal.vue?vue&type=script&lang=js&"
export * from "./UpgradePlanModal.vue?vue&type=script&lang=js&"
import style0 from "./UpgradePlanModal.vue?vue&type=style&index=0&id=68bb844c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bb844c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDialog,VImg,VRow})
